// extracted by mini-css-extract-plugin
module.exports = {"container":"Numbers_container__1j8sn","tab":"Numbers_tab__2FuZu","item":"Numbers_item__3yrol","green_p":"Numbers_green_p__1VvlG","purple_p":"Numbers_purple_p__3KB8b"};